'use client';

//* Components
import Page from '@/components/common/Page';
import ScrollText from '@/components/sections/ScrollText';
import FormSection from '@/components/sections/FormSection';
import OurCulture from '@/components/pages/about-us/OurCulture';
import AboutUsHero from '@/components/pages/about-us/AboutUsHero';
import DetailedInfo from '@/components/pages/about-us/DetailedInfo';
import WhyZoyasSection from '@/components/sections/WhyZoyasSection';

//* Style
import AboutUsStyle from '@/styles/pages/AboutUsStyle';

const AboutUsTemplate = ({ pageData }) => {
	return (
		<Page className='about'>
			<AboutUsStyle>
				<AboutUsHero
					title={pageData.title}
					row={pageData.rows[0]}
				/>

				<DetailedInfo {...pageData.rows[1]} />

				<ScrollText isSection={false} />

				<OurCulture {...pageData.culture} />

				<WhyZoyasSection />

				<FormSection />
			</AboutUsStyle>
		</Page>
	);
};

export default AboutUsTemplate;
